import React from "react";
import {eventBus} from "../../../pagelayout/EventBus";
import {snowplowTrackEvent} from "utils/snowplow.js";
import * as reduxSelectors from "../../../store/application.reducers";
import {connect} from "react-redux";
import AccountingGridNew from "./AccountingGridNew.component";
import { Button, ButtonType } from "components/common/Button.component";
import { ArrowLeftToLineIcon, ArrowDownToLine } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

class AccountingGridPanel extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            gridToggled: undefined,
            rows: 0,
            totalRows: 0,
            gridWidth: document.body.clientWidth
        }

        this.toggleAccountingGrid = this.toggleAccountingGrid.bind(this);
        this.onUpdateRows = this.onUpdateRows.bind(this);
        this.setGridWidth = this.setGridWidth.bind(this);
        this.trackPanelCollapsing = this.trackPanelCollapsing.bind(this);
        this.accountingGridRef = React.createRef();
    }

    componentDidMount() {
        this.setGridWidth();
        eventBus.on('@@grid/refreshGridLayout', this.setGridWidth);
        this.getOwnerWindow()?.addEventListener('resize', this.setGridWidth);

        if (typeof ResizeObserver !== 'undefined' && this.accountingGridRef.current) {
            this.resizeObserver = new ResizeObserver(() => {
                this.setGridWidth();
            });
            this.resizeObserver.observe(this.accountingGridRef.current);
        }
    }

    componentWillUnmount() {
        this.getOwnerWindow()?.removeEventListener('resize', this.setGridWidth);
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
            this.resizeObserver = null;
        }
    }

    getOwnerWindow() {
        return this.accountingGridRef.current?.ownerDocument?.defaultView ?? window;
    }

    setGridWidth() {
        this.setState({
            gridWidth: this.accountingGridRef.current?.clientWidth
        });
    }

    toggleAccountingGrid(event) {
        let newState = this.state.gridToggled === undefined ? true : !this.state.gridToggled;
        this.setState({
            gridToggled: newState
        });
    }

    onUpdateRows({rows, totalRows}) {
        this.setState({rows, totalRows});
    }

    trackPanelCollapsing(isCollapsed) {
        snowplowTrackEvent({
            category: "external_editor_panel",
            action: "external_editor_collapsing",
            label: "external_editor_panel",
            value: isCollapsed ? "collapsed" : "extended"
        }, this.props.userConfiguration);
    }


    render() {
        const accountingGridVisible = this.props.task?.hasAccountingGrid || this.props.task?.allowGridEdit || (this.props.taskDetails && this.props.taskDetails.allowGridEdit);
        const panelHeight = this.state.totalRows < 3 ? 200 : (this.state.totalRows * 30) + 120;
        const ownerWindow = this.getOwnerWindow();
        const ownerDocument = this.accountingGridRef.current?.ownerDocument ?? document;
        const windowHeight = ownerWindow?.innerHeight || ownerDocument.documentElement.clientHeight || ownerDocument.body.clientHeight;
        const relativePanelHeight = panelHeight >= windowHeight - 240 ? windowHeight - 240 : panelHeight;

        if (accountingGridVisible) {
            return (
                <div className={`grid-layout-accounting-grid ${this.props.renderInPortal ? 'in-portal' : ''}`} data-cy="taskDetails.accountingGridPanel">
                    <div className="grid-panel-wrapper">
                        <div className="grid-panel">
                            <div className="grid-panel-header d-flex justify-content-between align-items-center">
                                <strong>
                                    {this.props.translate("accoutingGrid.Accounting")}
                                    {this.state.rows !== 0 && this.state.totalRows !== 0
                                        ? <span>
                                            {`(${this.state.rows} ${this.props.translate("accoutingGrid.of")} ${this.state.totalRows})`}
                                        </span>
                                        : null
                                    }
                                </strong>


                                {!this.props.inDetachedWindow && (
                                    <div className="d-flex justify-content-end">
                                        <Button type= {ButtonType.GHOST}
                                                onClick={() => {
                                                    this.trackPanelCollapsing(true);
                                                    this.props.onRenderInPortalChange(true);
                                                }}
                                                disabled={this.props.renderInPortal}
                                                title={this.props.translate("taskDetail.placeAtTheSide")}
                                                iconOnly={true}
                                                icon={<ArrowLeftToLineIcon size={ICON_SIZE.MEDIUM}/>}/>
                                        <Button type= {ButtonType.GHOST}
                                                onClick={() => {
                                                    this.trackPanelCollapsing(false);
                                                    this.props.onRenderInPortalChange(false);
                                                }}
                                                disabled={!this.props.renderInPortal}
                                                title={this.props.translate("taskDetail.placeAtTheBottom")}
                                                iconOnly={true}
                                                icon={<ArrowDownToLine size={ICON_SIZE.MEDIUM}/>}/>
                                    </div>
                                )}

                            </div>
                            <div className="accounting-grid" ref={this.accountingGridRef}
                                 style={{ height: relativePanelHeight }}>
                                <AccountingGridNew className="h-100"
                                                   width={this.state.gridWidth}
                                                   taskId={this.props.params.taskId}
                                                   translate={this.props.translate}
                                                   readOnly={this.props.isHistory || this.props.task.isHandled}
                                                   language={this.props.userLanguage}
                                                   lineChangeWarning={(value) => {
                                                       this.setState({ lineWarning: value });
                                                   }}
                                                   companyId={this.props.companyId}
                                                   onUpdateRows={this.onUpdateRows}
                                                   toggle={this.toggleAccountingGrid} />
                            </div>
                        </div>
                    </div>
                </div>);
        }
        return null;
    }
}

const mapStateToProps = function(store) {
    return {
        userConfiguration: reduxSelectors.getUsersData(store),
        companyId: reduxSelectors.getUsersCurrentContextId(store)
    };
};

const connected = connect(mapStateToProps, {})(AccountingGridPanel);
export default connected;
